<template>
  <div class="adventures-container">
    <router-view />
  </div>
</template>

<script lang="ts">
export default {
  name: 'Adventures',
};
</script>

<style lang="scss">
.adventures-container {
  background-color: var(--grey-background-subdued);
  min-height: 100vh;
  position: relative;
  padding-bottom: 3rem;
}

@media (min-width: 640px) {
  .adventures-container {
    height: auto;
  }
}

main:has(.create-adventure) ~ footer,
main:has(.edit-adventure) ~ footer {
  display: none;
}
</style>
